import gql from 'graphql-tag';
import flightOption from './flightOption.fragment.graphql.js';

export default gql`
  ${flightOption}

query flights($flightSearchCriteria: FlightSearchCriteriaInput!) {
  transactionId
  flights(flightSearchCriteria: $flightSearchCriteria) {
    departing {
      ...FlightOptionFragment
      __typename
    }
    returning {
      ...FlightOptionFragment
      __typename
    }
    loyaltyFare {
      discount
      __typename
    }
    bundleOffers {
      maxSavedPrice {
        amount
        currency
        __typename
      }
      maxSavedPriceFor
      list {
        bundleReference
        id
        tier
        name
        icon
        banner
        discount {
          ... on PercentDiscount {
            value
            __typename
          }
          ... on FlatDiscount {
            amount
            currency
            __typename
          }
          __typename
        }
        discountType
        ancillaries {
          icon
          code
          type
          name
          numberOfIncludedItems
          price {
            amount
            currency
            __typename
          }
          strikethruPrice {
            amount
            currency
            __typename
          }
          discount {
            amount
            currency
            __typename
          }
          __typename
        }
        originalPricePerParty {
          amount
          currency
          __typename
        }
        bundlePricePerParty {
          amount
          currency
          __typename
        }
        originalPricePerPerson {
          amount
          currency
          __typename
        }
        bundlePricePerPerson {
          amount
          currency
          __typename
        }
        savingsPerParty {
          amount
          currency
          __typename
        }
        savingsPerPerson {
          amount
          currency
          __typename
        }
        __typename
      }
      allAncillariesList {
        type
        name
        icon
        __typename
      }
    }
  }
  order {
    items {
      id
      __typename
      ... on FlightOrderItem {
        flight {
          id
          __typename
        }
        __typename
      }
      ... on ShowOrderItem {
        id
        type
        show {
          categoryCode
          __typename
        }
        __typename
      }
    }
    __typename
  }
}
`;
